/*
 * Página "Historia y patrimonio" (/historia).
 *
 * Cómo completarla:
 *  - Escribe el texto de cada sección en "texto". Admite HTML sencillo:
 *    <p>párrafos</p>, <strong>negrita</strong>, <em>cursiva</em>, <ul><li>listas</li></ul>.
 *  - "imagen": nombre de una foto ya subida desde el panel (carpeta img/gallery),
 *    por ejemplo "sd_1234abcd.webp". Vacío = sin foto.
 *  - Puedes añadir, quitar o reordenar secciones.
 *  - Mientras una sección no tenga texto, se muestra "Contenido en preparación".
 *  - Cuando esté lista, pon publicada: true en src/contenido/config.js.
 */

export default {
  clave: "historia",
  eyebrow: "La parroquia",
  titulo: "Historia y patrimonio",
  entradilla: "",
  imagen: "",
  icono: "account_balance",

  // Datos destacados (se ocultan los que no tengan valor)
  datos: [
    { icono: "calendar_month", etiqueta: "Construcción", valor: "" },
    { icono: "architecture", etiqueta: "Estilo", valor: "" },
    { icono: "location_on", etiqueta: "Ubicación", valor: "Calle Mayor, Cartagena" },
    { icono: "military_tech", etiqueta: "Parroquia", valor: "Castrense" },
  ],

  secciones: [
    { id: "origenes", icono: "history_edu", titulo: "Orígenes", texto: "", imagen: "" },
    { id: "dominicos", icono: "church", titulo: "Los dominicos en Cartagena", texto: "", imagen: "" },
    { id: "castrense", icono: "military_tech", titulo: "Parroquia castrense", texto: "", imagen: "" },
    { id: "arquitectura", icono: "architecture", titulo: "El templo y su arquitectura", texto: "", imagen: "" },
    { id: "patrimonio", icono: "palette", titulo: "Patrimonio artístico", texto: "", imagen: "" },
    { id: "cofradias", icono: "groups", titulo: "Cofradías y Semana Santa", texto: "", imagen: "" },
  ],

  // Obras destacadas del patrimonio (tarjetas con foto). Vacío = no se muestra.
  obras: [
    // { titulo: "Retablo mayor", descripcion: "Siglo XVIII…", imagen: "sd_xxx.webp" },
  ],

  // Álbum de la galería relacionado (id del álbum en el panel). 0 = ninguno.
  albumId: 0,
};
